import { useState, useEffect } from 'react';

const useAgeVerification = () => {
  const [isVerified, setIsVerified] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);

  useEffect(() => {
    // Function to check verification status from localStorage
    const checkAgeVerification = () => {
      const ageVerified = localStorage.getItem('ageVerified');
      setIsVerified(ageVerified === 'true');
    };

    // Check age verification status when the component mounts
    checkAgeVerification();

    // Listen to changes in localStorage (if you have other parts of the app changing this)
    window.addEventListener('storage', checkAgeVerification);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('storage', checkAgeVerification);
    };
  }, []);

  const verifyAge = () => {
    setShowModal(true);
  };

  const handleConfirm = (link: string) => {
    localStorage.setItem('ageVerified', 'true');
    setIsVerified(true);
    setShowModal(false);
    window.open(link, '_blank');
  };

  const handleCloseModal = () => {
    setShowModal(false);
    // Optionally, take action if the user refuses to verify their age.
  };

  return { isVerified, verifyAge, showModal, handleConfirm, handleCloseModal };
};

export default useAgeVerification;
